export default function OrderIcon({ className }: any) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <rect x="5" y="3" width="12.8333" height="15.5833" rx="2" stroke="currentColor" strokeWidth="1.5" />
      <path d="M8.66699 7.58398H14.167" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8.66699 11.25H14.167" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M8.66699 14.918H12.3337" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
